module.exports = __webpack_public_path__ + "static/media/train1.abef7ba1.png";